// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1ons7","calendarButtons":"ClockData_calendarButtons__WzZQ4"};